import { withStyles } from '@material-ui/core/styles'
import { noop } from 'lodash'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import Icon from '../Icon'

export const FlashMessageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  padding: 16px;
  border: 1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`};
  border-radius: 5px;
  border-left: 4px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`};

  &.success {
    border-left-color: ${props => props.theme.status.successBorder};
  }

  &.error {
    border-left-color: ${props => props.theme.status.errorBorder};
  }

  &.warning {
    border-left-color: ${props => props.theme.status.warningBorder};
  }

  &.info {
    border-left-color: ${props => props.theme.status.infoBorder};
  }

  > .message-title {
    font-weight: bold;
    margin-bottom: 20px;
  }
  .message-icon {
    float: right;
  }
`
class FlashMessage extends React.Component {
  state = {
    showMessage: true,
  }

  timerID = null

  componentDidMount() {
    const { showInterval } = this.props
    this.startTimer(showInterval)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showInterval === null || nextProps.showInterval === undefined) {
      this.setState({ showMessage: true })
      this.startTimer(nextProps.showInterval)
    }
  }

  startTimer(time) {
    const { onDisappear } = this.props
    if (time) {
      clearTimeout(this.timerID)
      this.timerID = setTimeout(() => {
        this.setState({
          showMessage: false,
        })
        onDisappear()
      }, time)
    }
  }

  render() {
    const { canClose, classes, type, title, children } = this.props
    const { showMessage } = this.state
    let ICON = null
    if (type === 'success') {
      ICON = <Icon iconName="tick" className={classes.success} iconSize={22} />
    } else if (type === 'warning') {
      ICON = <Icon iconName="danger" className={classes.warning} iconSize={22} />
    } else if (type === 'error') {
      ICON = <Icon iconName="error" className={classes.error} iconSize={22} />
    } else if (type === 'info') {
      ICON = <Icon iconName="Info" iconType="info" className={classes.info} iconSize={22} />
    }
    return (
      showMessage && (
        <ThemeProvider theme={theme}>
          <FlashMessageWrapper className={[type, classes.messageContainer].join(' ')}>
            <div style={{ display: 'flex' }}>
              <div className={classes.iconContainer}>{ICON}</div>
              {title && (
                <div>
                  <div className={classes.messageTitle}>{title}</div>
                  {canClose && (
                    <Icon
                      iconName="cross"
                      iconSize={22}
                      className="message-icon"
                      onClick={() => {
                        this.setState({
                          showMessage: false,
                        })
                      }}
                      aria-label="Close"
                    />
                  )}
                  <div className={classes.messageContent}>{children}</div>
                </div>
              )}
            </div>
          </FlashMessageWrapper>
        </ThemeProvider>
      )
    )
  }
}

FlashMessage.defaultProps = {
  canClose: false,
  type: 'info',
  showInterval: 5000,
  onDisappear: noop,
}

const styles = () => ({
  messageContainer: {
    paddingRight: theme.spacing.spacer,
  },
  iconContainer: {
    paddingRight: theme.spacing(4),
  },
  messageTitle: {
    fontWeight: theme.typography.fontWeightBolder,
    marginBottom: theme.spacing.unitFourpx,
  },
  messageContent: {
    fontSize: theme.typography.fontSizeSm,
    color: theme.status.infoColor,
  },
  success: {
    color: `${theme.status.successColor} !important`,
  },
  error: {
    color: `${theme.status.errorColor} !important`,
  },
  warning: {
    color: `${theme.status.warningColor} !important`,
  },
})

export default withStyles(styles)(FlashMessage)
